const FuelTankStatus = {
    ACTIVE: "ACTIVE",
    ARCHIVED: "ARCHIVED"
}

export default FuelTankStatus;